import { render, staticRenderFns } from "./entry_review.vue?vue&type=template&id=46dc7670&scoped=true"
import script from "./entry_review.vue?vue&type=script&lang=js"
export * from "./entry_review.vue?vue&type=script&lang=js"
import style0 from "./entry_review.vue?vue&type=style&index=0&id=46dc7670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc7670",
  null
  
)

export default component.exports